import type { CollaborativeMember } from '@/types/collaborative/collaborativeList';

/**
 * Base props shared by all share modal variants
 */
interface BaseShareModalProps {
  isOpen: boolean;
  onClose: () => void;
  urlKey: string;
  listName: string;
}

/**
 * Props for personal list sharing
 */
export interface PersonalListShareProps extends BaseShareModalProps {
  listType: 'personal';
  /** Current note-sharing state for the list, used to seed the modal's toggle without mutating it. */
  isNotesPublic?: boolean;
}

/**
 * Props for collaborative list sharing
 */
export interface CollaborativeListShareProps extends BaseShareModalProps {
  listType: 'collaborative';
  existingMembers: CollaborativeMember[];
  maxMembers: number;
}

/**
 * Discriminated union for ShareListModal props
 */
export type ShareListModalProps = PersonalListShareProps | CollaborativeListShareProps;

/**
 * Type guard for personal list props
 */
export function isPersonalListProps(props: ShareListModalProps): props is PersonalListShareProps {
  return props.listType === 'personal';
}

/**
 * Type guard for collaborative list props
 */
export function isCollaborativeListProps(props: ShareListModalProps): props is CollaborativeListShareProps {
  return props.listType === 'collaborative';
}
